var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverOnWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.579 2.02a8.076 8.076 0 0 0-1.222.006C8.703 2.87 7.926 4.174 7.423 6h5.1c-.507-1.827-1.289-3.135-1.944-3.98zm2.817.737c.46.898.884 1.976 1.187 3.243h2.343a8.055 8.055 0 0 0-3.53-3.243zM17.746 8H14.93c.07.633.118 1.29.118 2 0 .708-.049 1.366-.118 2h2.817c.165-.64.253-1.31.253-2s-.088-1.36-.253-2zm-.82 6h-2.344a14.74 14.74 0 0 1-1.174 3.237A8.055 8.055 0 0 0 16.926 14zm-6.316 3.977c.652-.856 1.418-2.167 1.915-3.977H7.428c.497 1.804 1.263 3.115 1.913 3.973a8.07 8.07 0 0 0 1.27.004zm-4.084-.772A14.726 14.726 0 0 1 5.367 14H3.074a8.056 8.056 0 0 0 3.452 3.205zM2.253 12h2.764a18.263 18.263 0 0 1-.117-2c0-.709.047-1.367.116-2H2.253A7.986 7.986 0 0 0 2 10c0 .69.088 1.36.253 2zm.82-6h2.295c.299-1.25.715-2.318 1.167-3.21A8.056 8.056 0 0 0 3.074 6zM10 0c5.522 0 10 4.478 10 10s-4.478 10-10 10S0 15.522 0 10 4.478 0 10 0zM7.036 12h5.877c.078-.627.135-1.282.135-2 0-.719-.057-1.374-.135-2h-5.88a16.133 16.133 0 0 0-.133 2c0 .718.057 1.373.136 2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10-10h40v40h-40z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverOnWhite);
export default __webpack_public_path__ + "static/media/discover-on-white.610be3f1.svg";
export { ForwardRef as ReactComponent };